module.exports = __webpack_public_path__ + "static/strafe2-f7707127a73a197f35c6b0a8cd28ac81.png";